import { makeVar } from "@apollo/client"
import { SettingsPageFilter } from "generated/graphql"

const emptySettingsPageFilter: SettingsPageFilter = { searchText: "" }

const filter = makeVar(emptySettingsPageFilter)

export default filter
